import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import Tab_ScheduleManagement_Calendar from './Tab_ScheduleManagement_Calendar';
import Tab_ScheduleManagement_Timetable from './Tab_ScheduleManagement_Timetable';
import Controls_ScheduleManagement_Map_Selector from './Controls_ScheduleManagement_Map_Selector';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { Context_UI } from '../../Contexts/Context_UI';
import List_Timeline from './List_Timeline';
import UI_List_Manager from '../ERUMAUI/UI_List_Manager';


export default function Panel_ScheduleManagement_Center() {
    const UI = useContext(Context_UI);
    const { Account, Loading, Logout } = useAuth();
    const { Schedules, Schedules_Pending_Initial, Schedules_Pending_Final, Time_Range_Parse, Status_Parse, Schedule_Display, Schedules_ByUser, Schedule_Information, Schedule_inPast } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const [Timetable_Room, Timetable_Room_Set] = useState(null);

    const Location = useLocation();
    const Parameters = new URLSearchParams(Location.search);
    const Mode = Parameters.get('view') || "Timeline";
    let Mode_View = "Tab_Timeline";
    switch (Mode) {
        case "Timeline":
            Mode_View = "Tab_Timeline";
            break;
        case "Requests":
            Mode_View = "Tab_Requests";
            break;
        case "List":
            Mode_View = "Tab_List";
            break;
        case "Calendar":
            Mode_View = "Tab_Calendar";
            break;
        case "Table":
            Mode_View = "Tab_Table";
            break;
    }
    // useEffect(() => {
    //     console.error(Schedules);
    // }, [])



    const Handle_Click = async (ID) => {
        await Schedule_Display(ID);
        if (Panel_Right_State == "Collapsed") {
            Panel_Toggle("Right");
        }
    }

    const Handle_Change = (ID) => {
        Timetable_Room_Set(ID);
    }

    const [SearchQuery, SearchQuery_Set] = useState("");

    const Filtered_Schedules = Schedules?.filter(item => {
        const query = SearchQuery.trim().toLowerCase();
        if (!query) return true;
        return (
            item.Name.toLowerCase().includes(query) ||
            (item.Description && item.Description.toLowerCase().includes(query)) ||
            (item.RoomName && item.RoomName.toLowerCase().includes(query))
        );
    });


    if (Loading) {
        return null;
    }

    return (

        <div style={{padding: "20px"}}>
            {/* <h1 className='General_Title'>
                Wednesday, 3 September 2025
            </h1>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                <UI_Card
                    Shape="Rectangle"
                    Text="Pending requests"
                    Figure="10"
                    Color="Red"
                />
                <UI_Card
                    Shape="Rectangle"
                    Text="Activities today"
                    Figure="21"
                />
            </div> */}
            <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                {Account.Access.Reservation.Approve.Initial && Schedules_Pending_Initial.length > 0 ?
                    <UI_Card Shape="Rectangle" Text="Pending for OSA approval" Figure={Schedules_Pending_Initial.length} Color="Red" onClick={() => UI.Page_ChangePage("/schedules/manage?view=OSA", "Loading")} />
                    :
                    ""
                }


                {Account.Access.Reservation.Approve.Final && Schedules_Pending_Final.length > 0 ?
                    <UI_Card Shape="Rectangle" Text="Pending for GSU approval" Figure={Schedules_Pending_Final.length} Color="Red" onClick={() => UI.Page_ChangePage("/schedules/manage?view=GSU", "Loading")} />
                    :
                    ""
                }
            </div>
            <UI_Horizontal_Tabs
                Presentation="Categories"
                Selectors={[
                    {
                        Text: "Timeline view",
                        Icon: <UI_Icon Name="List" />
                    },
                    {
                        Text: "Your reservation requests",
                        Icon: <UI_Icon Name="List" />
                    },
                    {
                        Text: "List view",
                        Icon: <UI_Icon Name="List" />
                    },
                    {
                        Text: "Calendar view",
                        Icon: <UI_Icon Name="Calendar" />
                    },
                    {
                        Text: "Table view",
                        Icon: <UI_Icon Name="Table" />
                    }
                ]}
                UIDs={[
                    "Timeline",
                    "Owned",
                    "List",
                    "Calendar",
                    "Table"
                ]}
                Selected={Mode_View}
                Components={[
                    <>
                        <h2 className='General_Title'>
                            Upcoming activities
                        </h2>
                        <List_Timeline />
                    </>,
                    <>
                        <h2 className='General_Title'>
                            Your reservation requests
                        </h2>
                        <UI_List_Manager
                            id="Schedules_List"
                            Input={Schedules_ByUser}
                            Keys_Searchable={["Name", "Room", "Description"]}
                            Filters={{
                                // Status: ["Active", "Pending", "Cancelled"],
                                Status: {
                                    Options: [
                                        {
                                            Label: "Fully approved",
                                            Icon: <UI_Icon Name="Check" />
                                        },
                                        {
                                            Label: "Partially approved",
                                            Icon: <UI_Icon Name="Partial" />
                                        },
                                        {
                                            Label: "Rejected",
                                            Icon: <UI_Icon Name="Cross" />
                                        },
                                        {
                                            Label: "Pending",
                                            Icon: <UI_Icon Name="Pending" />
                                        }
                                    ],
                                    Logic: (Item, Selected) => {
                                        const Initial = Item.Approval.Initial.State;
                                        const Final = Item.Approval.Final.State;
                                        switch (Selected) {
                                            case "Fully approved":
                                                return Initial === "Approved" && Final === "Approved";
                                            case "Partially approved":
                                                return (
                                                    (Initial === "Approved" && Final === "Pending") || (Initial === "Pending" && Final === "Approved")
                                                );
                                            case "Rejected":
                                                return Initial === "Rejected" || Final === "Rejected";
                                            case "Pending":
                                                return Initial === "Pending" && Final === "Pending";
                                            case "All":
                                            default:
                                                return true;
                                        }
                                    }
                                }
                            }}
                            Options_Sort={[
                                {
                                    Label: "Name (A-Z)",
                                    Key: "Name",
                                    Direction: "Ascending"
                                },
                                // {
                                //     Label: "Newest",
                                //     Key: "Time.Start",
                                //     Direction: "Ascending"
                                // }
                                {
                                    Label: "Upcoming",
                                    Logic: (a, b) => {
                                        const now = new Date().setHours(0, 0, 0, 0); // Get current time as a number
                                        const timeA = new Date(a.Time.Start).getTime();
                                        const timeB = new Date(b.Time.Start).getTime();

                                        const aIsInPast = timeA < now;
                                        const bIsInPast = timeB < now;

                                        if (aIsInPast && !bIsInPast) {
                                            return 1;
                                        }

                                        if (!aIsInPast && bIsInPast) {
                                            return -1; // Pushes b to the end
                                        }

                                        return timeA - timeB;
                                    }
                                }
                            ]}
                            Output={(Item) => (
                                <UI_Card
                                    Type="Schedule_List"
                                    Figure={{
                                        Title: Item.Name,
                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                        Chip: Status_Parse(Item),
                                    }}
                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                    onClick={() => Handle_Click(Item._id)}
                                />
                            )}
                        />
                        {/* <UI_Horizontal_Tabs
                            Selectors={[
                                {
                                    Text: "Approved activities",
                                    Icon: <UI_Icon Name="Check" />
                                },
                                {
                                    Text: "Pending for approval",
                                    Icon: <UI_Icon Name="Pending" />
                                },
                                {
                                    Text: "Rejected activities",
                                    Icon: <UI_Icon Name="Cross" />
                                }
                            ]}
                            UIDs={[
                                "Approved",
                                "Pending",
                                "Rejected"
                            ]}
                            Selected="Tab_Approved"
                            Components={[
                                <>
                                    <div className='General_List' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules_ByUser.map((Item) => (
                                            <>

                                                {Item.Approval.Initial.State == "Approved" && Item.Approval.Final.State == "Approved"  ?
                                                    <UI_Card
                                                        Type="Schedule_List"
                                                        Figure={
                                                            {
                                                                Title: Item.Name,
                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                Chip: Status_Parse(Item)
                                                            }
                                                        }
                                                        Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                        onClick={() => Handle_Click(Item._id)}
                                                    />
                                                    :
                                                    ""
                                                }
                                            </>

                                        ))}
                                    </div>
                                </>,
                                <>
                                    <div className='General_List' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules_ByUser.map((Item) => (
                                            <>
                                                {Item.Approval.Initial.State == "Pending" || (Item.Approval.Initial.State !== "Rejected" && Item.Approval.Final.State == "Pending") ?
                                                    <UI_Card
                                                        Type="Schedule_List"
                                                        Figure={
                                                            {
                                                                Title: Item.Name,
                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                Chip: Status_Parse(Item)
                                                            }
                                                        }
                                                        Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                        onClick={() => Handle_Click(Item._id)}
                                                    />
                                                    :
                                                    ""
                                                }
                                            </>

                                        ))}
                                    </div>
                                </>,
                                <>
                                    <div className='General_List' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules_ByUser.map((Item) => (
                                            <>
                                                {Item.Approval.Initial.State == "Rejected" || Item.Approval.Final.State == "Rejected" ?
                                                    <UI_Card
                                                        Type="Schedule_List"
                                                        Figure={
                                                            {
                                                                Title: Item.Name,
                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                Chip: Status_Parse(Item)
                                                            }
                                                        }
                                                        Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                        onClick={() => Handle_Click(Item._id)}
                                                    />
                                                    :
                                                    ""
                                                }
                                            </>
                                        ))}
                                    </div>
                                </>
                            ]}
                        /> */}
                    </>,
                    <>
                        <div className='General_Split' Split="3">
                            {/* <UI_Input_Text
                                Input_Placeholder="Time"
                                Value_Set_Enable={true}
                                // Value="Wed, 3 Sept 2025"
                                Input_Type="date"
                            />
                            <UI_Dropdown
                                InitialTitle="Search by..."
                                Items={[
                                    "Search by...",
                                    "Room",
                                    "Activity type",
                                    "Search query"
                                ]}
                                id="Test"
                            /> */}
                            {/* <UI_Input_Text
                                Input_Placeholder="Search query"
                                onChange={(e) => SearchQuery_Set(e.target.value)}
                            /> */}
                        </div>
                        <h2 className='General_Title'>
                            All activities
                        </h2>
                        <UI_List_Manager
                            id="Schedules_List"
                            Input={Filtered_Schedules}
                            Keys_Searchable={["Name", "Room", "Description"]}
                            Filters={{
                                // Status: ["Active", "Pending", "Cancelled"],
                                Status: {
                                    Options: [
                                        {
                                            Label: "Fully approved",
                                            Icon: <UI_Icon Name="Check"/>
                                        },
                                        {
                                            Label: "Partially approved",
                                            Icon: <UI_Icon Name="Partial" />
                                        },
                                        {
                                            Label: "Rejected",
                                            Icon: <UI_Icon Name="Cross" />
                                        },
                                        {
                                            Label: "Pending",
                                            Icon: <UI_Icon Name="Pending" />
                                        }
                                    ],
                                    Logic: (Item, Selected) => {
                                        const Initial = Item.Approval.Initial.State;
                                        const Final = Item.Approval.Final.State;
                                        switch (Selected) {
                                            case "Fully approved":
                                                return Initial === "Approved" && Final === "Approved";
                                            case "Partially approved":
                                                return (
                                                    (Initial === "Approved" && Final === "Pending") || (Initial === "Pending" && Final === "Approved")
                                                );
                                            case "Rejected":
                                                return Initial === "Rejected" || Final === "Rejected";
                                            case "Pending":
                                                return Initial === "Pending" && Final === "Pending";
                                            case "All":
                                            default:
                                                return true;
                                        }
                                    }
                                }
                            }}
                            Options_Sort={[
                                {
                                    Label: "Name (A-Z)",
                                    Key: "Name",
                                    Direction: "Ascending"
                                },
                                // {
                                //     Label: "Newest",
                                //     Key: "Time.Start",
                                //     Direction: "Ascending"
                                // }
                                {
                                    Label: "Upcoming",
                                    Logic: (a, b) => {
                                        const now = new Date().setHours(0,0,0,0); // Get current time as a number
                                        const timeA = new Date(a.Time.Start).getTime();
                                        const timeB = new Date(b.Time.Start).getTime();

                                        const aIsInPast = timeA < now;
                                        const bIsInPast = timeB < now;

                                        if (aIsInPast && !bIsInPast) {
                                            return 1;
                                        }

                                        if (!aIsInPast && bIsInPast) {
                                            return -1; // Pushes b to the end
                                        }

                                        return timeA - timeB;
                                    }
                                }
                            ]}
                            Output={(Item) => (
                                <UI_Card
                                    Type="Schedule_List"
                                    Figure={{
                                        Title: Item.Name,
                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                        Chip: Status_Parse(Item),
                                    }}
                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                    onClick={() => Handle_Click(Item._id)}
                                />
                            )}
                        />
                        {/* <div className='General_List' style={{ marginTop: "10px" }}>
                            {Filtered_Schedules?.map((Item) => (
                                <UI_Card
                                    Type="Schedule_List"
                                    Figure={
                                        {
                                            Title: Item.Name,
                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                            Chip: Status_Parse(Item)
                                        }
                                    }
                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                    onClick={() => Handle_Click(Item._id)}
                                />
                            ))}
                        </div> */}
                    </>,
                    <>
                        <h2 className='General_Title'>
                            Calendar
                        </h2>
                        <Tab_ScheduleManagement_Calendar Schedules={Schedules} InitialView="Month" />
                    </>,
                    <>
                        <h2 className='General_Title'>
                            Timetable
                        </h2>
                        <div style={{ position: "relative", paddingTop: "10px", paddingBottom: "10px", zIndex: "100" }}>
                            <Controls_ScheduleManagement_Map_Selector
                                onRoomSelect={(Room) => Handle_Change(Room)}
                            />
                        </div>

                        <Tab_ScheduleManagement_Timetable
                            Schedules={Schedules}
                            InitialView="Week"
                            Room={Timetable_Room}
                        />
                    </>

                ]} />






        </div>
    );
}
